let BASE_URL = process.env.REACT_APP_ENV === 'production' ? 'https://api.vlab.live/v1' : 'https://stg-api.vlab.live/v1'

export default BASE_URL
